import { Component, OnChanges, inject, ChangeDetectionStrategy, input, output } from '@angular/core';
import {GuruEntity} from '../../../model/guru-entity';
import {ModelService} from '../../../services/model-service';
import {SelectionUtils} from '../../selection-utils';
import {ConfigurationSection, UserStateService} from '../../../services/user-state.service';
import { FormsModule } from '@angular/forms';

import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-vertical-stud-primary-valve-package',
    templateUrl: './vertical-stud-primary-valve-package.component.html',
    styleUrls: ['./vertical-stud-primary-valve-package.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIcon, FormsModule]
})
export class VerticalStudPrimaryValvePackageComponent implements OnChanges {
  private modelService = inject(ModelService);
  private userStateService = inject(UserStateService);


  readonly invalidEntities = input.required<string[]>();
  readonly engineKey = input.required<string>();
  readonly selectionEntities = input.required<GuruEntity[]>();
  readonly valueChanged = output<void>();
  valveSizeSelection!: GuruEntity;
  isolationBallValveSelection!: GuruEntity;
  controlValveSelection!: GuruEntity;
  hoseKitSelection!: GuruEntity;
  isExpanded = true;
  private sectionKey = ConfigurationSection.PRIMARY_VALVE_PACKAGE;

  constructor() {
    this.isExpanded = !this.userStateService.isConfigurationSectionCollapsed(this.sectionKey);
  }

  ngOnChanges(): void {
    this.valveSizeSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USPrimaryValveSize');
    this.isolationBallValveSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USPrimaryIsolationBallValve');
    this.controlValveSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USPrimaryControlValve');
    this.hoseKitSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USPrimaryIsolation');
  }

  selectionChanged(entity: GuruEntity, newValue: string): void {
    this.modelService.setValue(entity.Name, this.engineKey(), newValue).subscribe(() => this.valueChanged.emit());
  }

  toggleExpansion(): void {
    this.isExpanded = !this.isExpanded;
    this.userStateService.setCollapsedValue(this.sectionKey, this.isExpanded);
  }

  getExpansionIcon(): string {
    return this.isExpanded ? 'arrow_drop_up' : 'arrow_drop_down';
  }

  isInvalidSelection(entityName: string) {
    return this.invalidEntities() && this.invalidEntities().indexOf(entityName) >= 0;
  }

}
